import { Image } from '../types/entities/image.entity';

const VIDEO_PATH_PATTERN = /\.(mp4|avi|mpeg|mov)(\?|$)/i;

export function isGalleryVideo(image: Image): boolean {
    if (image.type === 'video') {
        return true;
    }

    if (image.path && VIDEO_PATH_PATTERN.test(image.path)) {
        return true;
    }

    return false;
}

export function galleryThumbSrc(image: Image): string | undefined {
    if (isGalleryVideo(image)) {
        return image.preview ?? undefined;
    }

    return image.path;
}

export function getImageLabel(image: Image): string {
    const display = image.display_name?.trim();
    if (display) {
        return display;
    }

    const original = image.original_name?.trim();
    if (original) {
        return original;
    }

    return '';
}
